const STORAGE_KEY = "signaris_net_target_tenant";

let current: string | null = null;
const listeners = new Set<(slug: string | null) => void>();

try {
  current = localStorage.getItem(STORAGE_KEY);
} catch {
  // ignore
}

export function getTargetTenant(): string | null {
  return current;
}

export function setTargetTenant(slug: string | null): void {
  current = slug;
  try {
    if (slug) localStorage.setItem(STORAGE_KEY, slug);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  for (const l of listeners) l(slug);
}

export function subscribeTargetTenant(fn: (slug: string | null) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
